import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { useLocale } from 'hooks/useLocale';
import { isRCFOffer } from './SummaryCard.helpers';
import styles from './SummaryCard.module.css';

// Rendered as a flex sibling of SummaryCard inside .summaryCardContainer.
// Zero-height, invisible — forces the container to stay at the correct minimum
// width when switching between product types, without any JS measurement.
// Uses the same .column CSS class as real columns so it tracks responsive
// breakpoints automatically.
export const SummaryCardWidthAnchor = () => {
  const { selectedApplication: application } = useReviewOffer();
  const { isDE } = useLocale();

  const formalOffers = application?.formal_offer_sets?.[0]?.formal_offers ?? [];
  const flexiCount = formalOffers.filter((o) => !isRCFOffer(o, isDE)).length;
  const rcfCount = formalOffers.filter((o) => isRCFOffer(o, isDE)).length;
  const anchorColumnCount = Math.max(flexiCount, rcfCount) + 1; // +1 for the labels column

  return (
    <div className={styles.widthAnchor} aria-hidden="true">
      {Array.from({ length: anchorColumnCount }, (_, i) => (
        <div key={i} className={styles.column} />
      ))}
    </div>
  );
};
